import React, { Component } from 'react';
import env from "react-dotenv";
import getUserId from '../utils/getUserId';

let UNBLOCK_URL = `${env.API_URL}/p10/unblockDime`;
let DELETE_USER_URL = `${env.API_URL}/deleteDime/admin`; // Correct variable name from original

const TrashIcon = () => (
  <svg style={{width: '14px', height: '14px'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

const UnlockIcon = () => (
  <svg style={{width: '14px', height: '14px'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
  </svg>
);

class BlockedDime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      serverResponse: '',
      isUnblocking: false,
      isDeleting: false,
      showSuccessToast: false
    };
    this.toastTimeout = null;
  }

  componentDidMount() {
    const userId = getUserId();
    if (!userId) {
      console.error('BlockedDime mounted but no userId available!');
    }
  }

  componentWillUnmount() {
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }
  }

  onSubmitUnblockDime = () => {
    const userId = getUserId();
    const userIsAdmin = window.uAdministrator;
    
    if (!userId) {
      console.error('No user ID available for unblocking');
      this.setState({
        serverResponse: "Please sign in to unblock dimes.",
        modalIsOpen: true
      });
      return;
    }

    if (!userIsAdmin) {
      this.setState({
        serverResponse: "You must be an administrator to unblock dimes.",
        modalIsOpen: true
      });
      return;
    }
    
    this.setState({ isUnblocking: true });

    fetch(UNBLOCK_URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': env.API_KEY
      },
      body: JSON.stringify({
        administrator: userIsAdmin,
        dime_id: this.props.Id || this.props.dimeId
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data) {
          // Show success toast
          this.setState({
            showSuccessToast: true,
            isUnblocking: false
          });
          
          // Hide toast after 2 seconds
          this.toastTimeout = setTimeout(() => {
            if (this.toastTimeout) {
              this.setState({ showSuccessToast: false });
            }
          }, 2000);
          
          // Trigger refresh
          if (this.props.onActionCompleted) {
            this.props.onActionCompleted();
          }
          
          if (this.props.setTest) {
            this.props.setTest();
          }
        }
      })
      .catch(error => {
        console.error('Error unblocking dime:', error);
        this.setState({
          serverResponse: "Error unblocking dime.",
          modalIsOpen: true,
          isUnblocking: false
        });
      });
  };

  onSubmitDelete = () => {
    const userId = getUserId();
    const userIsAdmin = window.uAdministrator;
    
    console.log('Delete - Props:', {
      Id: this.props.Id,
      dimeId: this.props.dimeId,
      userId: userId,
      userIsAdmin: userIsAdmin
    });
    
    if (!userId) {
      console.error('No user ID available for deleting');
      this.setState({
        serverResponse: "Please sign in to delete dimes.",
        modalIsOpen: true
      });
      return;
    }

    if (!userIsAdmin) {
      this.setState({
        serverResponse: "You must be an administrator to delete dimes.",
        modalIsOpen: true
      });
      return;
    }

    // Confirm destructive action
    if (!window.confirm('Are you sure you want to permanently delete this dime? This action cannot be undone.')) {
      return;
    }
    
    this.setState({ isDeleting: true });

    const dimeIdToDelete = this.props.Id || this.props.dimeId;
    
    if (!dimeIdToDelete) {
      console.error('No dime ID available!');
      this.setState({
        serverResponse: "Error: Dime ID not found.",
        modalIsOpen: true,
        isDeleting: false
      });
      return;
    }

    const requestBody = {
      id: dimeIdToDelete,
      administrator: userIsAdmin
    };
    
    console.log('Delete request body (matching original):', requestBody);

    fetch(DELETE_USER_URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': env.API_KEY
      },
      body: JSON.stringify(requestBody)
    })
      .then(async response => {
        console.log('Delete response status:', response.status);
        
        // Check if response is OK
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Delete error response:', errorText);
          throw new Error(`Delete failed with status ${response.status}`);
        }
        
        // Try to parse as JSON
        try {
          return await response.json();
        } catch (jsonError) {
          console.warn('Response is not JSON, treating as success');
          return { success: true }; // If not JSON but status is OK, consider it success
        }
      })
      .then(data => {
        console.log('Delete response data:', data);
        if (data) {
          // Show modal for delete confirmation since it's destructive
          this.setState({
            serverResponse: 'Dime deleted successfully.',
            modalIsOpen: true,
            isDeleting: false
          });
          
          // Trigger refresh after short delay
          if (this.props.onActionCompleted) {
            setTimeout(() => {
              this.props.onActionCompleted();
            }, 500);
          }
          
          if (this.props.setTest) {
            this.props.setTest();
          }
        }
      })
      .catch(error => {
        console.error('Error deleting dime:', error);
        this.setState({
          serverResponse: "Unable to delete dime. The delete feature may be temporarily unavailable. Please try unblocking instead or contact support.",
          modalIsOpen: true,
          isDeleting: false
        });
      });
  };

  render() {
    const { modalIsOpen, serverResponse, isUnblocking, isDeleting, showSuccessToast } = this.state;

    return (
      <>
        <div className="blocked-dime-container">
          {/* Admin Actions */}
          <div className="admin-actions">
            <button
              onClick={this.onSubmitUnblockDime}
              disabled={isUnblocking || isDeleting}
              className="action-btn unblock-btn"
            >
              {isUnblocking ? (
                <>
                  <div className="spinner-small"></div>
                  <span>Unblocking...</span>
                </>
              ) : (
                <>
                  <UnlockIcon />
                  <span>Unblock Dime</span>
                </>
              )}
            </button>

            <button
              onClick={this.onSubmitDelete}
              disabled={isDeleting || isUnblocking}
              className="action-btn delete-btn"
            >
              {isDeleting ? (
                <>
                  <div className="spinner-small"></div>
                  <span>Deleting...</span>
                </>
              ) : (
                <>
                  <TrashIcon />
                  <span>Delete Dime</span>
                </>
              )}
            </button>
          </div>
        </div>

        {/* Success Toast */}
        {showSuccessToast && (
          <div className="success-toast">
            <svg className="toast-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span>Dime unblocked!</span>
          </div>
        )}

        {/* Modal - For errors and delete confirmation */}
        {modalIsOpen && (
          <div className="modal-overlay" onClick={() => this.setState({ modalIsOpen: false })}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-icon">
                <svg className="checkmark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="modal-title">Status</h3>
              <p className="modal-message">{serverResponse}</p>
              <button onClick={() => this.setState({ modalIsOpen: false })} className="modal-close-btn">
                Close
              </button>
            </div>
          </div>
        )}

        <style>{`
          .blocked-dime-container {
            padding: 16px;
            background: white;
            border-radius: 8px;
          }

          .admin-actions {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .action-btn {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 10px 16px;
            border-radius: 8px;
            font-weight: 600;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s;
            border: none;
          }

          .action-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          .unblock-btn {
            background: linear-gradient(135deg, #10b981, #059669);
            color: white;
            box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
          }

          .unblock-btn:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
          }

          .delete-btn {
            background: linear-gradient(135deg, #ef4444, #dc2626);
            color: white;
            box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
          }

          .delete-btn:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
          }

          .spinner-small {
            width: 14px;
            height: 14px;
            border: 2px solid currentColor;
            border-top-color: transparent;
            border-radius: 50%;
            animation: spin 0.6s linear infinite;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          /* Success Toast */
          .success-toast {
            position: fixed;
            bottom: 24px;
            left: 50%;
            transform: translateX(-50%);
            background: linear-gradient(135deg, #34d399, #10b981);
            color: white;
            padding: 12px 20px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
            z-index: 1001;
            font-weight: 600;
            font-size: 14px;
            animation: slideUp 0.3s ease-out;
          }

          .toast-icon {
            width: 20px;
            height: 20px;
            stroke-width: 2.5;
          }

          @keyframes slideUp {
            from {
              transform: translateX(-50%) translateY(20px);
              opacity: 0;
            }
            to {
              transform: translateX(-50%) translateY(0);
              opacity: 1;
            }
          }

          /* Modal styles */
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            backdrop-filter: blur(4px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            padding: 16px;
            animation: fadeIn 0.2s;
          }

          .modal-content {
            background: white;
            border-radius: 20px;
            padding: 32px;
            max-width: 400px;
            width: 100%;
            text-align: center;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
            animation: zoomIn 0.2s;
          }

          .modal-icon {
            width: 64px;
            height: 64px;
            background: linear-gradient(135deg, #34d399, #10b981);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 20px;
          }

          .checkmark {
            width: 32px;
            height: 32px;
            color: white;
          }

          .modal-title {
            font-size: 24px;
            font-weight: bold;
            color: #111827;
            margin: 0 0 12px 0;
          }

          .modal-message {
            color: #6b7280;
            margin: 0 0 24px 0;
            line-height: 1.5;
          }

          .modal-close-btn {
            width: 100%;
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 12px;
            font-weight: 600;
            font-size: 15px;
            cursor: pointer;
            transition: all 0.2s;
          }

          .modal-close-btn:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
          }

          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          @keyframes zoomIn {
            from {
              transform: scale(0.95);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}</style>
      </>
    );
  }
}

export default BlockedDime;